import ReactDatepicker, { registerLocale } from 'react-datepicker';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { enUS, es, pt } from 'date-fns/locale';
import type { ComponentProps } from 'react';
import { useLoadBundleCssOnce } from '#/zustand-stores/loadCssBundleStore';

//:horizon://import reactDatepickerCssUrl from 'react-datepicker/dist/react-datepicker.css?url';

registerLocale(I18nLocale.EN, enUS);
registerLocale(I18nLocale.ES, es);
registerLocale(I18nLocale.PT, pt);

export function ReactDatePickerWrapper(
  props: ComponentProps<typeof ReactDatepicker>,
) {
  useLoadBundleCssOnce('reactDatepicker');

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReactDatepicker {...props} />;
}
